import { EMPTY_LIST, EMPTY_STRING } from '../constants/common'
import {
  EMAIL_ACCOUNT_TYPE_KEY,
  EMAIL_AVAILABLE_ACCOUNT_TYPES,
  EMAIL_INFO_ACCOUNT,
  EMAIL_REPLY_FORM_HTML_BLOCK_ID,
  EMAIL_SERVICE_ACCOUNT,
  EMAIL_SYSTEM_ACCOUNT_ID,
} from '../constants/email'

import { toHTMLElement } from './html'

export function isInfoEmailAccount(email) {
  return email?.description === EMAIL_INFO_ACCOUNT
}

export function isSystemEmailAccount(email) {
  return email?.value === EMAIL_SYSTEM_ACCOUNT_ID
}

export function isServiceEmailAccount(email) {
  return email?.description === EMAIL_SERVICE_ACCOUNT
}

/**
 * Removes the `#reply` block from an email HTML string, mirroring the
 * `removeSignature` pattern from `utils/signature`.
 *
 * @param {string} message
 * @returns {string}
 */
export function removeReplyBlock(message) {
  const textElement = toHTMLElement(message)
  const replyNode = textElement.querySelector(
    `#${EMAIL_REPLY_FORM_HTML_BLOCK_ID}`
  )

  if (!replyNode) {
    return message
  }

  replyNode.remove()

  return textElement.innerHTML || EMPTY_STRING
}

export function getEmailAvailableAccounts(
  accounts = EMPTY_LIST,
  key = EMAIL_ACCOUNT_TYPE_KEY
) {
  return accounts.filter(
    account =>
      EMAIL_AVAILABLE_ACCOUNT_TYPES.includes(account[key]) ||
      isInfoEmailAccount(account) ||
      isServiceEmailAccount(account)
  )
}

export function getRecipientRealId(option) {
  if (Number.isSafeInteger(option?.realId)) {
    return option.realId
  }

  return Number.isSafeInteger(option?.value) ? option.value : null
}

export function getPreviewRecipientValue(recipient) {
  const realId = getRecipientRealId(recipient)

  if (realId !== null) {
    return [realId, recipient.email]
  }

  return recipient.value
}

export function getPreviewGoogleTemplateDependencies({
  baseDependencies,
  dependencyValues,
}) {
  return dependencyValues
    ? { ...baseDependencies, ...dependencyValues }
    : baseDependencies
}
